"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _moment = _interopRequireDefault(require("moment"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _sender = require("../Shapes/sender.shape");

var _product = require("../Shapes/product.shape");

var _constants = require("../constants");

var _constants2 = require("../CreateGift/constants");

var _shippingInfo = require("../Shapes/shippingInfo.shape");

var _GiftImage = _interopRequireDefault(require("./GiftImage"));

var statusTitles = {
  [_constants2.giftStatuses.GIFT_CREATED]: 'Gift created: Researching',
  [_constants2.giftStatuses.NEED_MORE_INFO]: 'We need more info',
  [_constants2.giftStatuses.REVIEW]: 'Gift created: Researching',
  [_constants2.giftStatuses.PRODUCTS_PROPOSED]: 'Options ready',
  [_constants2.giftStatuses.SCHEDULED]: 'Invite scheduled',
  [_constants2.giftStatuses.DISABLED]: 'Invite disabled'
};
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      minHeight: '100px',
      padding: spacing(2),
      marginBottom: spacing(3),
      position: 'relative'
    },
    propertyTitle: {
      width: '84px',
      fontSize: '14px'
    },
    propertyValue: {
      color: palette.text.primary,
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center'
    },
    avatar: {
      width: '14px',
      height: '14px',
      marginRight: spacing(0.5)
    },
    productTitle: {
      color: palette.primary.main,
      maxWidth: '260px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      cursor: 'pointer'
    },
    triangle: function triangle(_ref2) {
      var isShowStatuses = _ref2.isShowStatuses;
      return {
        width: 'calc(100% - 20px)',
        height: 20,
        position: 'absolute',
        overflow: 'hidden',
        boxShadow: '0 16px 10px -17px rgba(0, 0, 0, 0.5)',
        marginTop: spacing(2),
        visibility: isShowStatuses ? 'visible' : 'hidden',
        animation: isShowStatuses ? "ldt-float-right-in 0.5s" : "ldt-slide-left-out 0.5s",
        transition: 'visibility 0.5s linear',
        '&::after': {
          content: '',
          position: 'absolute',
          width: 25,
          height: 25,
          background: palette.common.white,
          transform: 'rotate(45deg)',
          top: '-12px',
          left: 'calc(50% - 20px)',
          boxShadow: '0 2px 2px rgba(0, 0, 0, 0.1)'
        }
      };
    }
  };
});

var GiftCard = function GiftCard(_ref3) {
  var campaign = _ref3.campaign,
      sentAs = _ref3.sentAs,
      sentBy = _ref3.sentBy,
      statusId = _ref3.statusId,
      product = _ref3.product,
      onClick = _ref3.onClick,
      isShowStatuses = _ref3.isShowStatuses,
      createdAt = _ref3.createdAt,
      shippingInfo = _ref3.shippingInfo;
  var classes = useStyles({
    isShowStatuses
  });
  var title = (0, _react.useMemo)(function () {
    return statusTitles[statusId] || product.name;
  }, [statusId, product]);
  var actionName = (0, _react.useMemo)(function () {
    return statusId > _constants2.giftStatuses.PRODUCTS_PROPOSED ? 'Send by' : 'Created by';
  }, [statusId]);
  var localDate = (0, _react.useMemo)(function () {
    return createdAt ? (0, _moment.default)(createdAt).local().format(_constants.USER_FULL_NUMBER_DATE_FORMAT) : null;
  }, [createdAt]);
  return /*#__PURE__*/_react.default.createElement(_material.Paper, {
    square: true,
    elevation: 1,
    className: classes.root,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    wrap: "nowrap"
  }, /*#__PURE__*/_react.default.createElement(_GiftImage.default, {
    status: statusId,
    title: title,
    image: product && product.image
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h4",
    className: classes.productTitle
  }, /*#__PURE__*/_react.default.createElement(_ui.TableCellTooltip, {
    lengthToShow: 25,
    title: title
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    className: classes.propertyTitle
  }, actionName), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    style: {
      color: '#4a4a4a',
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center'
    },
    className: classes.propertyValue
  }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    style: {
      width: 14,
      height: 14
    },
    src: sentBy.avatar,
    className: classes.avatar
  }), sentBy.full_name)), sentAs && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    className: classes.propertyTitle
  }, "Sent as"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    className: classes.propertyValue
  }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    src: sentAs.avatar,
    className: classes.avatar
  }), " ", sentAs.full_name)), createdAt && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    className: classes.propertyTitle
  }, "Created on"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    className: classes.propertyValue
  }, localDate)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    className: classes.propertyTitle
  }, "Campaign"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    className: classes.propertyValue
  }, campaign || 'One-off gift')), shippingInfo && !R.isEmpty(shippingInfo) && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    className: classes.propertyTitle
  }, shippingInfo.tracking_carrier), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    className: classes.propertyValue
  }, shippingInfo.tracking_number)))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.triangle
  }));
};

GiftCard.propTypes = {
  sentBy: _sender.senderShape.isRequired,
  statusId: _propTypes.default.number.isRequired,
  isShowStatuses: _propTypes.default.bool.isRequired,
  createdAt: _propTypes.default.string,
  campaign: _propTypes.default.string,
  onClick: _propTypes.default.func,
  sentAs: _sender.senderShape,
  product: _product.productShape,
  shippingInfo: _shippingInfo.shippingInfoShape
};
GiftCard.defaultProps = {
  campaign: null,
  sentAs: null,
  createdAt: null,
  product: null,
  onClick: function onClick() {},
  shippingInfo: {}
};
var _default = GiftCard;
exports.default = _default;